export enum CameraActionType {
  CAMERA_SELECT,
  CAMERA_ERROR,
  CAMERA_EMPTY,
  CAMERA_CHANGE,
  CAMERA_RESET,
  GET_CAMERAS,
}

export interface camera {
  id: string;
  kind: string;
  label: string;
  empty: boolean;
  error: string;
}

export interface ICameraAction<T> {
  type: keyof typeof CameraActionType;
  payload?: T;
}

export const selectCamera = (camera: any): ICameraAction<any> => {
  return {
    type: "CAMERA_SELECT",
    payload: camera,
  };
};

export const getCameras = (cameras: any): ICameraAction<any> => {
  return {
    type: "GET_CAMERAS",
    payload: cameras,
  };
};

export const errorCamera = (error: Error): ICameraAction<any> => {
  return {
    type: "CAMERA_ERROR",
    payload: error,
  };
};

export const changeCamera = (
  newCamera: any,
  field: string
): ICameraAction<any> => {
  return {
    type: "CAMERA_CHANGE",
    payload: { newCamera, field },
  };
};

export const emptyCamera = (): ICameraAction<any> => {
  return {
    type: "CAMERA_EMPTY",
  };
};
